// Confetti Effect for Cart Drawer
// Based on https://www.kirilv.com/canvas-confetti/

class CartConfetti {
  constructor() {
    // iPhone-like vibrant confetti colors
    this.colors = [
      '#FF3B30', '#FF9500', '#FFCC00', '#4CD964', // iOS colors
      '#5AC8FA', '#007AFF', '#5856D6', '#FF2D55', // iOS colors
      '#FF375F', '#FFD60A', '#00C7BE', '#BF5AF2', // More vibrant colors
      '#64D2FF', '#30B0C7', '#E5E5EA', '#FFFFFF'  // Light colors
    ];
    this.duration = 2000; // Shorter duration as requested (2 seconds)
    this.initialized = false;
    this.canvas = null;
    this.shapes = ['rectangle', 'circle', 'strip', 'oval', 'triangle']; // Added triangle shape
    this.gravity = 0.07; // Higher gravity for smoother falling
    this.wind = 0.01; // No wind effect
    this.windChange = 0.0005; // No wind change
    this.currentWind = 0.01;
    this.animationRunning = false; // Track if animation is running
    this.overlayElement = null; // White overlay element
  }

  init() {
    // Always recreate the canvas to ensure it works multiple times
    this.cleanup(); // Clean up any existing canvas
    
    // Create canvas element
    this.canvas = document.createElement('canvas');
    this.canvas.className = 'confetti-canvas';
    this.canvas.style.pointerEvents = 'none';
    this.canvas.style.zIndex = '1000';
    
    // Create white overlay element
    this.overlayElement = document.createElement('div');
    this.overlayElement.className = 'confetti-overlay';
    this.overlayElement.style.backgroundColor = 'rgba(255, 255, 255, 0)';
    this.overlayElement.style.transition = 'background-color 0.5s ease';
    this.overlayElement.style.pointerEvents = 'none';
    this.overlayElement.style.zIndex = '999'; // Below the canvas
    
    // Set positioning based on context
    let isCartPage = false;
    if (document.querySelector('.cart__page')) {
      isCartPage = true;
    }
    
    if (isCartPage) {
      // Cart page context - use fixed positioning to cover the viewport
      this.canvas.style.position = 'fixed';
      this.canvas.style.top = '0';
      this.canvas.style.left = '0';
      this.canvas.style.width = '100%';
      this.canvas.style.height = '100%';
      
      this.overlayElement.style.position = 'fixed';
      this.overlayElement.style.top = '0';
      this.overlayElement.style.left = '0';
      this.overlayElement.style.width = '100%';
      this.overlayElement.style.height = '100%';
    } else {
      // Cart drawer context - use absolute positioning
      this.canvas.style.position = 'absolute';
      this.canvas.style.top = '0';
      this.canvas.style.left = '0';
      this.canvas.style.width = '100%';
      this.canvas.style.height = '100%';
      
      this.overlayElement.style.position = 'absolute';
      this.overlayElement.style.top = '0';
      this.overlayElement.style.left = '0';
      this.overlayElement.style.width = '100%';
      this.overlayElement.style.height = '100%';
    }
    
    // Add canvas and overlay to appropriate container based on context
    let container;
    
    // Check if we're on the cart page first (priority)
    if (document.querySelector('.cart__page')) {
      // Cart page context - use document.body for full viewport coverage
      container = document.body;
      console.log('Confetti initialized for cart page (body-level)');
    } 
    // Only use cart drawer if we're not on the cart page
    else if (document.querySelector('.cart__side .box')) {
      // Cart drawer context
      container = document.querySelector('.cart__side .box');
      console.log('Confetti initialized for cart drawer');
    }

    if (container) {
      // Append the overlay and canvas
      container.appendChild(this.overlayElement);
      container.appendChild(this.canvas);
      this.initialized = true;
    }
  }
  
  // Clean up previous canvas and overlay if they exist
  cleanup() {
    const existingCanvas = document.querySelector('.confetti-canvas');
    if (existingCanvas) {
      existingCanvas.remove();
    }
    
    const existingOverlay = document.querySelector('.confetti-overlay');
    if (existingOverlay) {
      existingOverlay.remove();
    }
    
    this.initialized = false;
  }

  createElements(count, shootUp = false) {
    const elements = [];
    
    for (let i = 0; i < count; i++) {
      const shape = this.shapes[Math.floor(Math.random() * this.shapes.length)];
      const color = this.colors[Math.floor(Math.random() * this.colors.length)];
      
      // More varied sizes for realism
      const size = Math.random() * 12 + 4;
      
      // Aspect ratio for rectangles (some long, some wide)
      const aspectRatio = Math.random() * 3 + 0.5;
      
      // Spread confetti across the entire width of the cart drawer for a fuller effect
      const x = Math.random() * this.canvas.width;
      
      // All confetti should shoot up from bottom only
      let initialVelocityY;
      let startY;
      
      // All particles shoot up from bottom
      // Negative velocity means shooting upward - reduced velocity so confetti doesn't go too high
      initialVelocityY = -(Math.random() * 6 + 3); // Reduced upward velocity
      
      // Start from bottom area for explosion effect
      startY = this.canvas.height - (Math.random() * 20); // Very bottom
      
      // Add horizontal velocity component for explosion effect
      // Particles further from center have stronger horizontal velocity
      const distanceFromCenter = Math.abs(x - (this.canvas.width / 2)) / (this.canvas.width / 2);
      const horizontalVelocityMultiplier = 3; // Adjust for stronger/weaker spread
      const horizontalVelocity = (x < this.canvas.width / 2 ? -1 : 1) * 
                                distanceFromCenter * horizontalVelocityMultiplier;
      
      // Set initial horizontal velocity
      this.initialVelocityX = horizontalVelocity;
      
      // Initial rotation
      const initialRotation = Math.random() * Math.PI * 2;
      
      elements.push({
        shape: shape,
        color: color,
        x: x,
        y: startY,
        width: shape === 'rectangle' || shape === 'strip' ? size * aspectRatio : size,
        height: shape === 'rectangle' || shape === 'oval' ? size / aspectRatio : size,
        tilt: Math.random() * 10 - 5,
        wobble: 0, // No wobble effect
        wobbleSpeed: 0, // No wobble speed
        wobbleAngle: Math.random() * Math.PI * 2,
        velocityY: initialVelocityY,
        velocityX: (Math.random() * 0.2 - 0.1), // Very slight horizontal velocity for scattering
        rotationSpeed: (Math.random() * 0.1 + 0.01) * (Math.random() < 0.5 ? -1 : 1), // Slower rotation
        rotation: initialRotation,
        opacity: 0.9 + Math.random() * 0.1,
        flip: Math.random() < 0.5,
        flipRate: Math.random() * 0.02 + 0.005, // Slower flip rate
        flipAngle: 0,
        scale: 1.0, // Initial scale
        scaleSpeed: Math.random() * 0.01 + 0.005, // Scale animation speed
        scaleDirection: Math.random() < 0.5 ? 1 : -1, // Scale up or down
        shimmer: Math.random() < 0.3 // 30% of particles will shimmer
      });
    }
    
    return elements;
  }

  render(elements, context, timestamp) {
    // Update wind
    this.currentWind += (Math.random() * 2 - 1) * this.windChange;
    this.currentWind = Math.max(-0.1, Math.min(0.1, this.currentWind));
    
    elements.forEach(element => {
      context.save();
      
      // Apply position and rotation
      context.translate(element.x, element.y);
      context.rotate(element.rotation);
      
      // Apply flip effect
      if (element.flip) {
        element.flipAngle += element.flipRate;
        const flipScale = Math.abs(Math.cos(element.flipAngle));
        context.scale(flipScale, 1);
      }
      
      // Apply scale animation for a more dynamic effect
      element.scale += element.scaleSpeed * element.scaleDirection;
      if (element.scale > 1.2) {
        element.scaleDirection = -1;
      } else if (element.scale < 0.8) {
        element.scaleDirection = 1;
      }
      context.scale(element.scale, element.scale);
      
      // Apply shimmer effect for some particles
      if (element.shimmer) {
        const shimmerIntensity = (Math.sin(timestamp * 0.01) + 1) * 0.5; // Value between 0 and 1
        context.fillStyle = element.color;
        context.shadowColor = 'white';
        context.shadowBlur = 5 * shimmerIntensity;
        context.globalAlpha = element.opacity * (0.8 + 0.2 * shimmerIntensity);
      } else {
        // Set color and opacity
        context.fillStyle = element.color;
        context.globalAlpha = element.opacity;
      }
      
      // Draw confetti piece based on shape
      switch(element.shape) {
        case 'circle':
          context.beginPath();
          context.arc(0, 0, element.width / 2, 0, 2 * Math.PI, false);
          context.fill();
          break;
          
        case 'rectangle':
          // Add slight shadow for 3D effect
          context.shadowColor = 'rgba(0,0,0,0.1)';
          context.shadowBlur = 1;
          context.shadowOffsetX = 0.5;
          context.shadowOffsetY = 0.5;
          context.fillRect(-element.width / 2, -element.height / 2, element.width, element.height);
          break;
          
        case 'strip':
          // Thin strip like real paper confetti
          context.fillRect(-element.width / 2, -element.height / 8, element.width, element.height / 4);
          break;
          
        case 'oval':
          context.beginPath();
          context.ellipse(0, 0, element.width / 2, element.height / 2, 0, 0, 2 * Math.PI);
          context.fill();         
          break;
          
        case 'triangle':
          // Draw a triangle
          context.beginPath();
          context.moveTo(0, -element.height / 2);
          context.lineTo(-element.width / 2, element.height / 2);
          context.lineTo(element.width / 2, element.height / 2);
          context.closePath();
          context.fill();
          break;
      }
      
      context.restore();
      
      // Apply physics - gravity increases velocity over time
      element.velocityY += this.gravity;
      
      // Apply wind and wobble effects
      element.wobbleAngle += element.wobbleSpeed;
      element.velocityX += this.currentWind + Math.sin(element.wobbleAngle) * element.wobble;
      
      // Update position
      element.y += element.velocityY;
      element.x += element.velocityX;
      
      // Update rotation
      element.rotation += element.rotationSpeed + element.velocityX * 0.05;
      
      // Air resistance
      element.velocityX *= 0.99;
      
      // Make confetti stay at the bottom instead of fading out
      if (element.y > this.canvas.height - 5) {
        // Stop falling when it hits the bottom
        element.y = this.canvas.height - 5 - (Math.random() * 10); // Varied heights at bottom
        element.velocityY = 0;
        element.velocityX *= 0.7; // Slow down horizontal movement
        
        // Slowly fade out over time for performance
        element.opacity -= 0.001;
      }
      
      // Only remove elements that have moved out of view horizontally or have fully faded
      if (element.x < -50 || element.x > this.canvas.width + 50 || element.opacity <= 0) {
        elements.splice(elements.indexOf(element), 1);
      }
    });
  }

  play() {
    // If animation is already running, stop it first
    if (this.animationRunning) {
      this.cleanup();
      this.animationRunning = false;
      
      // Small delay to ensure cleanup is complete
      setTimeout(() => {
        this.startAnimation();
      }, 50);
      return;
    }
    
    this.startAnimation();
  }
  
  // Method to add free gift at the very end of the animation
  addFreeGiftAtEnd(freeGiftSlider, autoAddFreeGiftFunction) {
    // Wait until almost the end of the animation
    setTimeout(() => {
      // Hide the free gift section
      if (freeGiftSlider) {
        freeGiftSlider.style.display = 'none';
      }
      
      // Auto-add the first available free gift
      autoAddFreeGiftFunction();
    }, 1900); // 1.9 seconds - just before the animation ends
  }
  
  startAnimation() {
    // Initialize fresh canvas
    this.init();
    
    if (!this.canvas) return;
    
    // Set canvas dimensions
    this.canvas.width = this.canvas.offsetWidth;
    this.canvas.height = this.canvas.offsetHeight;
    
    const context = this.canvas.getContext('2d');
    
    // Create initial confetti with better vertical distribution
    const elements = [];
    
    // Create confetti that shoots up from the bottom and then falls back down
    // Increase the number of shooting confetti for a more dramatic effect
    const shootingConfetti = this.createElements(600, true);
    shootingConfetti.forEach((element, index) => {
      // All confetti starts from the bottom area
      element.y = this.canvas.height - 10 - (Math.random() * 20); // Very bottom
      
      // Make all initial confetti shoot upward with varied velocities
      // Reduced velocities to ensure they don't go too high above the screen
      element.velocityY = -(Math.random() * 7 + 5); // Reduced upward velocity
      
      // Add horizontal spread for a more natural effect
      const distanceFromCenter = Math.abs(element.x - (this.canvas.width / 2)) / (this.canvas.width / 2);
      const horizontalVelocityMultiplier = 2 + Math.random() * 2; // Varied horizontal spread
      element.velocityX = (element.x < this.canvas.width / 2 ? -1 : 1) * 
                          distanceFromCenter * horizontalVelocityMultiplier * Math.random();
    });
    elements.push(...shootingConfetti);
    
    // Fade in the white overlay
    if (this.overlayElement) {
      this.overlayElement.style.backgroundColor = 'rgba(255, 255, 255, 0.8)';
    }
    
    // Add more confetti over time
    let lastAddTime = 0;
    
    // Set animation as running
    this.animationRunning = true;
    
    // Animation loop
    let start = null;
    const animate = (timestamp) => {
      if (!start) start = timestamp;
      const progress = timestamp - start;
      
      // Use high-quality rendering for smoother animation
      context.clearRect(0, 0, this.canvas.width, this.canvas.height);
      
      // Enable image smoothing for better quality
      context.imageSmoothingEnabled = true;
      context.imageSmoothingQuality = 'high';
      
      this.render(elements, context, timestamp);
      
      // Add more confetti in smaller, more frequent bursts for a scattered effect
      if (timestamp - lastAddTime > 100 && progress < this.duration * 0.7) { // Only add more during first 70% of animation
        // Smaller bursts for a more scattered effect
        const burstSize = Math.floor(Math.random() * 10) + 5; // Smaller bursts
        
        // Create new confetti elements - only shooting up from bottom
        const newElements = this.createElements(burstSize * 2, true); // All shoot from bottom
        
        // Distribute confetti - focus on bottom-to-top effect
        newElements.forEach((element) => {
          // Start from the bottom
          element.y = this.canvas.height - 10 - (Math.random() * 20);
          
          // Reduced upward velocity so confetti doesn't go too high
          element.velocityY = -(Math.random() * 7 + 5);
          
          // Add more horizontal randomness too
          element.x = Math.random() * this.canvas.width;
        });
        
        elements.push(...newElements);
        lastAddTime = timestamp;
      }
      
      if (progress < this.duration && elements.length > 0) {
                requestAnimationFrame(animate);
      } else {
        // Start fading out the white overlay
        if (this.overlayElement) {
          this.overlayElement.style.backgroundColor = 'rgba(255, 255, 255, 0)';
        }
        
        // Clear canvas when animation is complete
        context.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.animationRunning = false; // Animation is no longer running
      }
    };
    
    requestAnimationFrame(animate);
  }
}

// Initialize confetti effect
document.addEventListener('DOMContentLoaded', function() {
  window.cartConfetti = new CartConfetti();
});
